import {useState, useEffect} from 'react';
import '../../Navbar.scss';
import SingleTransaction from './SingleTransaction';
import { getTransaction } from '../../../../apis/PicksAPI';

const PicksTransactions = ({yourBalance}) => {
const [allTransactions, setAllTransactions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const transactionResponse = await getTransaction(yourBalance.id);
                setAllTransactions(transactionResponse);
            } catch {
                console.error("Errore durante il recupero delle transazioni");
            }
        };
        fetchData();
    }, [yourBalance]);

    return (
        <div className='picks-tran-main'>
            {allTransactions.data && allTransactions.data.totalSize > 0 ? (
                <>
                    {allTransactions.data && allTransactions.data.data.map((element, _index) => (
                        <SingleTransaction
                            key={element.createdAt}
                            picks={element.picks}
                            reciver={element.receiverUsername}
                            reciverName={element.receiverDescription}
                            tranOwner={element.owner}
                            tranOwnerName={element.senderDescription}
                            accountOwner={yourBalance.owner}
                            date={element.createdAt}
                            description={element.senderNote}
                        />
                    ))}
                </>
            ) : (
                <p>No transactions found</p>
            )}
        </div>
    );
};

export default PicksTransactions;
